'use client';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import emailjs from 'emailjs-com';
import "@/styles/components/library/contact.css";

const Contact = () => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    setError(null);

    const securityAnswer = e.target.contact__security?.value?.trim();

    if (securityAnswer !== '9') {
      setLoading(false);
      setError('The security number is incorrect.');
      return;
    }

    emailjs.sendForm('service_cvl8ahd', 'template_40prk2i', e.target, 'vz_GHrsIdAo47INqu')
      .then(() => {
      setLoading(false);
      router.push('/confirm');
    }).catch((err) => {
      console.error('Email send failed:', err);
      setLoading(false);
      setError('Failed to send message. Please try again later.');
    });
  };
  
  return (
    <div className="contact">
      <div className="contact__form">
        {error && <div className="contact__error" role="alert">{error}</div>}
        <form id="contact_form-primary" name="contact_form-primary" method="post" action="#" onSubmit={handleSubmit} noValidate={false}>
          <fieldset disabled={loading}>
            <legend>Empire Nine Digital Contact Form:</legend>
            <ol className="contact__info" role="list">
              <li>
                <label htmlFor="contact__name">Name: <span className="contact__required">*</span></label>
                <input type="text" id="contact__name" name="contact__name" placeholder="Your name" required />
              </li>
              <li>
                <label htmlFor="contact__email">Email: <span className="contact__required">*</span></label>
                <input type="email" id="contact__email" name="contact__email" placeholder="Your email" required />
              </li>
              <li>
                <label htmlFor="contact__organisation">Organisation: <span className="contact__required">*</span></label>
                <input type="text" id="contact__organisation" name="contact__organisation" placeholder="Your organisation" required />
              </li>
              <li>
                <label htmlFor="contact__message">Message: <span className="contact__required">*</span></label>
                <textarea id="contact__message" name="contact__message" placeholder="Your message" rows="10" minLength="10" required></textarea>
              </li>
              <li>
                <label htmlFor="contact__security">Security: <span className="contact__required">*</span></label>
                <input type="number" id="contact__security" name="contact__security" placeholder="What number appears in my website?" required />
              </li>
              <li>
                <input type="submit" id="contact__submit" className="contact__submit" name="contact__submit" value={loading ? 'Sending...' : 'Send message'} />
              </li>
            </ol>
          </fieldset>
        </form>
      </div>
    </div>
  )
}

export default Contact;
